import {
  Dialog,
  Box,
  Modal,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { CustomButton } from '../../../v2/MUI_custom_component';
import IllustrationWrapper from '../../../v3/Illustrration/IllustrationWrapper';

const HumbeeModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  illustration,
  title = "Are you sure you want to exit?",
  subtitle = "This action cannot be undone. All data would be lost?",
  confirmLabel = "Yes",
  cancelLabel = "No",
  width = { xs: 'auto', md: 600 },
  buttonSx = { width: { xs: '100%', md: '100%' } },
  maxWidth = { xs: 'auto', md: 600 },
  topDesktop = '50%',
  topMobile = '20%',
  scrollable = true,
  maxHeight = '20%',
  zIndex = 1300,
  sx = {}
}) => {
  const handleCancelClick = () => {
    onClose();
  };

  const handleDeleteClick = () => {
    onConfirm();
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  return (
    <Modal 
      open={open} 
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: zIndex,
      }}
    >
      <Box
        sx={{
          borderRadius: 2,
          textAlign: 'center',
          width: width,
          maxWidth: maxWidth,
          p: 2,
          m: 0,
          gap: 4,
          backgroundColor: !isMobile ? '#ffffffd1' : '#ffffffd1',
          backdropFilter: 'blur(5px)',
          WebkitBackdropFilter: 'blur(5px)',
          // boxShadow: 24,
          display: 'flex',
          flexDirection: 'column',
          ...sx
        }}
      >
        <Box sx={{ textAlign: 'center'}}>
          <IllustrationWrapper
            illustration={illustration}
            title={title}
            subtitle={subtitle}
          />
      </Box>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', }}>
          <CustomButton
            variant="outlined"
            color="primary"
            label={cancelLabel}
            onClick={handleCancelClick}
            size="medium"
            sx={buttonSx}
          />
          {confirmLabel &&
            <CustomButton
              variant="filled" 
              color="primary"
              label={confirmLabel}
              onClick={handleDeleteClick}
              disabled={loading}
              loading={loading}
              size="medium"
              sx={buttonSx}
            />
          }
        </Box>
      </Box>
    </Modal>
  );
};

export default HumbeeModal;
